









































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class FlexButton extends Vue {
  @Prop(String) icon!: string;
  @Prop(String) text!: string;
  @Prop(Boolean) white!: boolean;
  @Prop(Boolean) gray!: boolean;
  @Prop(Boolean) dark!: boolean;
  @Prop(Boolean) purple!: boolean;
  @Prop(Boolean) secundaryBlue!: boolean;
  @Prop(Boolean) cancel!: boolean;
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) biggerIcon!: boolean;
  @Prop(Boolean) blueTwism!: boolean;
  @Prop(Boolean) pinkTwism!: boolean;
  @Prop(Boolean) link!: boolean;
  @Prop(Boolean) big!: boolean;
  @Prop(Boolean) whitePink!: boolean;
  @Prop(Boolean) secondary!: boolean;
  @Prop(Boolean) secondaryNew!: boolean;
  @Prop(Boolean) tertiary!: boolean;
  @Prop(Boolean) quartenary!: boolean;
  @Prop(Boolean) quintenary!: boolean;
  @Prop(Boolean) lightBlue!: boolean;
  @Prop(Boolean) senary!: boolean;
  @Prop(Boolean) whiteBlue!: boolean;
  @Prop(Boolean) outlineBlue!: boolean;
  @Prop(Boolean) small!: boolean;
  @Prop(Boolean) blueWhite!: boolean;
  @Prop() loading!: boolean;

  clicked(event: any) {
    this.$emit('clicked', event);
  }
}
